import { IconBell } from '@tabler/icons-react'

import { useComponentTranslation } from '@/hooks/use-component-translation'

import locales from './locales'

interface EmptyStateProps {
  tab: 'unread' | 'all'
}

export function EmptyState({ tab }: EmptyStateProps) {
  const { t } = useComponentTranslation(locales)

  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="bg-muted mb-3 rounded-full p-4">
        <IconBell className="text-muted-foreground/40 h-8 w-8" />
      </div>
      <p className="text-muted-foreground text-sm">{t(`empty.${tab}`)}</p>
    </div>
  )
}
